import {
  ArrowRightLeft,
  CircleStop,
  ClipboardList,
  FileText,
  GitBranch,
  Headphones,
  Image,
  LayoutGrid,
  LayoutTemplate,
  List,
  ListOrdered,
  MessageSquare,
  MousePointerClick,
  Reply,
  Send,
  Settings2,
  Sparkles,
  SplitSquareHorizontal,
  Video,
} from "lucide-react";
import { isAwaitPalette, isNotifyPalette } from "./workflowPaletteConstants";

/** Maps catalog `icon` strings from GET_CATALOG.palette to Lucide components. */
const PALETTE_ICON_MAP = {
  "collect-input": ClipboardList,
  condition: SplitSquareHorizontal,
  action: Settings2,
  "custom-action": Sparkles,
  handoff: Headphones,
  end: CircleStop,
  "invoke-workflow": GitBranch,
  "transfer-workflow": ArrowRightLeft,
  "whatsapp-text": MessageSquare,
  "whatsapp-image": Image,
  "whatsapp-video": Video,
  "whatsapp-document": FileText,
  "whatsapp-buttons": LayoutGrid,
  "whatsapp-list": List,
  "whatsapp-template": LayoutTemplate,
  "whatsapp-template-media": LayoutTemplate,
  "whatsapp-text-notify": Send,
  "whatsapp-image-notify": Image,
  "whatsapp-video-notify": Video,
  "whatsapp-document-notify": FileText,
  "whatsapp-template-notify": LayoutTemplate,
  "whatsapp-template-media-notify": LayoutTemplate,
  "whatsapp-text-await": Reply,
  "whatsapp-buttons-await": MousePointerClick,
  "whatsapp-list-await": ListOrdered,
  "whatsapp-image-await": Image,
  "whatsapp-video-await": Video,
  "whatsapp-document-await": FileText,
  "whatsapp-template-await": LayoutTemplate,
  "whatsapp-template-media-await": LayoutTemplate,
};

function iconFromPaletteType(paletteType) {
  if (!paletteType) return MessageSquare;
  if (paletteType.startsWith("custom.")) return Sparkles;
  if (paletteType.includes("collect_input")) return ClipboardList;
  if (paletteType.includes("condition")) return SplitSquareHorizontal;
  if (paletteType.includes("action")) return Settings2;
  if (paletteType.includes("handoff")) return Headphones;
  if (paletteType.includes(".end") || paletteType.endsWith("end")) return CircleStop;
  if (paletteType.includes("invoke_workflow")) return GitBranch;
  if (paletteType.includes("transfer_workflow")) return ArrowRightLeft;
  if (paletteType.includes("document")) return FileText;
  if (paletteType.includes("video")) return Video;
  if (paletteType.includes("image")) return Image;
  if (paletteType.includes("buttons")) return LayoutGrid;
  if (paletteType.includes("list")) return List;
  if (paletteType.includes("template")) return LayoutTemplate;
  if (isNotifyPalette(paletteType)) return Send;
  if (isAwaitPalette(paletteType)) return Reply;
  if (paletteType.startsWith("whatsapp.")) return MessageSquare;
  return MessageSquare;
}

/**
 * @param {string} [iconKey] - catalog `icon` field
 * @param {string} [paletteType] - fallback when icon key missing
 */
export function getPaletteIcon(iconKey, paletteType) {
  if (iconKey && PALETTE_ICON_MAP[iconKey]) {
    return PALETTE_ICON_MAP[iconKey];
  }
  return iconFromPaletteType(paletteType);
}
